import { getDuration } from './time'

export const calculateDailyLifetime = (daily, lifetime, StartDate, EndDate) => {
  const duration = getDuration(StartDate, EndDate)
  if (daily === -1 || lifetime === -1) {
    return ['Unlimited', 'Unlimited']
  }
  const calculatedDaily = daily || parseInt(Number(lifetime) / Number(duration))

  const calculatedLifeTime = lifetime || parseInt(Number(daily) * Number(duration))

  return [calculatedDaily, calculatedLifeTime]
}

export const lifetimeBudgetText = (daily, lifetime, dailyCost, lifetimeCost, StartDate, EndDate) => {
  const durationDays = getDuration(StartDate, EndDate)

  if (durationDays <= 0) {
    return [NaN, false]
  }

  if (lifetime > 0) {
    if (daily > 0) {
      return [Math.min(lifetime, daily * durationDays), false]
    }
    return [lifetime, false]
  }

  if (daily > 0) {
    return [daily * durationDays, false]
  }

  if (lifetimeCost > 0) {
    if (dailyCost > 0) {
      return [Math.min(lifetimeCost, dailyCost * durationDays), true]
    }
    return [lifetimeCost, true]
  }

  if (dailyCost > 0) {
    return [dailyCost * durationDays, true]
  }

  return ['Unlimited', false]
}

export default calculateDailyLifetime
